import { forwardRef, useState, type KeyboardEvent } from "react";
import { SendHorizonal } from "lucide-react";

/**
 * Поле питання — AC-AI-INPUT-STATES (M1). Стани: default · typing (кнопка
 * активна при непорожньому) · loading/disabled (поле disabled, причина — у
 * стані вище). Enter → надіслати.
 */
export const AssistantAskBox = forwardRef<HTMLInputElement, {
  onAsk: (q: string) => void;
  disabled?: boolean;
  placeholder?: string;
  size?: "lg" | "sm";
}>(function AssistantAskBox({ onAsk, disabled = false, placeholder, size = "lg" }, ref) {
  const [value, setValue] = useState("");
  const canSend = value.trim().length > 0 && !disabled;

  const fire = () => {
    if (!canSend) return;
    onAsk(value.trim());
    setValue("");
  };
  const onKey = (e: KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      fire();
    }
  };

  const pad = size === "lg" ? "px-3.5 py-2.5 text-sm" : "px-3 py-2 text-[13px]";

  return (
    <div className="flex gap-2">
      <input
        ref={ref}
        type="text"
        value={value}
        disabled={disabled}
        onChange={(e) => setValue(e.target.value)}
        onKeyDown={onKey}
        placeholder={placeholder ?? "Постав питання про роботу CRM…"}
        aria-label="Питання до помічника CRM"
        className={`flex-1 rounded-lg border border-border bg-background text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring disabled:opacity-55 ${pad}`}
      />
      <button
        type="button"
        onClick={fire}
        disabled={!canSend}
        className="inline-flex items-center gap-1.5 rounded-lg bg-primary px-4 text-sm font-semibold text-primary-foreground hover:bg-primary/90 disabled:opacity-50 disabled:hover:bg-primary"
      >
        <SendHorizonal className="h-4 w-4" aria-hidden />
        Запитати
      </button>
    </div>
  );
});
